import { Component } from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"

import { ProtectedRoute, MetrikaTracker } from "./helpers"
import { Account } from "./components"
import { Authorization, Intro } from "./widgets"
import { Home, Search, Organization, Booking, Bookings, Profile, Favourites, Reviews, Notifications, Help, Page404, Gifts, About, Contacts, PrivacyPolicy, PublicOffer } from "./pages"
import { Partner, ProPrivacyPolicy, ProPublicOffer } from "./pages/pro"

class App extends Component {

    render = () => {
        return (
            <Router>
                <MetrikaTracker />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/search" element={<Search />} />
                    <Route path="/organization/:url" element={<Organization />} />
                    <Route path="/booking" element={<ProtectedRoute><Booking /></ProtectedRoute>} />
                    <Route path="/bookings" element={<ProtectedRoute><Bookings /></ProtectedRoute>} />
                    <Route path="/favourites" element={<Favourites />} />
                    <Route path="/reviews" element={<ProtectedRoute><Reviews /></ProtectedRoute>} />
                    <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
                    <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                    <Route path="/account" element={<ProtectedRoute><Account hub /></ProtectedRoute>} />
                    <Route path="/help" element={<Help />} />
                    <Route path="/gifts" element={<Gifts />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contacts" element={<Contacts />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/public-offer" element={<PublicOffer />} />
                    <Route path="/partnership" element={<Partner />} />
                    <Route path="/partner/privacy-policy" element={<ProPrivacyPolicy />} />
                    <Route path="/partner/public-offer" element={<ProPublicOffer />} />
                    <Route path="*" element={<Page404 />} />
                </Routes>

                <Authorization />
                <Intro />
            </Router>
        )
    }
}

export default App
